import React from "react";
import type { SustainabilityItem } from "../types";
import { getMediaCentralUrl } from "../services/media-service";
import { useMetricEmitter } from "../contexts/MetricEmitterContext";
import { CPF_LEARN_MORE_URL } from "../../../../constants";

export interface SheetFooterProps {
  program: SustainabilityItem;
  className?: string;
}

export const SheetFooter: React.FC<SheetFooterProps> = ({
  program,
  className = "",
}) => {
  const metricEmitter = useMetricEmitter();

  // Track CPF logo click
  const handleCPFLogoClick = () => {
    metricEmitter.trackClick("lg");
  };
  const content = (
    <>
      {program.icon && (
        <h3 className="sheet-footer__icon">
          <img
            src={getMediaCentralUrl(
              program.icon.physicalId,
              program.icon.extension,
            )}
            alt={program.displayName}
            className="sheet-footer__program-icon"
            width={program.icon.width}
            height={program.icon.height}
          />
        </h3>
      )}
      <div className="sheet-footer__info">
        <span className="sheet-footer__description">
          {
            "This product is recognized by Climate Pledge Friendly. Look for the leaf to find products with sustainability features."
          }
        </span>
        &nbsp;
        <span className="sheet-footer__learn-more">
          {program.learnMoreLink?.data.displayText}
        </span>
      </div>
    </>
  );

  return (
    <div className={`sheet-footer ${className}`}>
      <a
        href={CPF_LEARN_MORE_URL}
        className="sheet-footer__content sheet-footer__content--link"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleCPFLogoClick}
      >
        {content}
      </a>
    </div>
  );
};
